module.exports = __webpack_public_path__ + "img/bg_bottom.c921eb62.svg";